import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-view-escalation',
  templateUrl: './view-escalation.component.html',
  styleUrls: ['./view-escalation.component.scss']
})
export class ViewEscalationComponent implements OnInit {
  escalation:any
  constructor(
    @Inject(MAT_DIALOG_DATA) private data
  ) { }

  ngOnInit() {
    this.escalation = this.data
    console.log(this.escalation)
  }
  getColorPriority(priority:any){
    let temp = priority.toLowerCase()
    switch(temp){
      case 'low':return 'rgba(240, 222, 124, 0.2)';
      case 'medium':return 'rgba(255, 217, 142, 0.5)';
      case 'high':return 'rgba(193, 35, 0, 0.33)';
      default:return 'black'
    }
  }
  getccUsers(users:any){
    let user = users.map((ele)=>ele.name).join(', ')
    return user
  }
  cancelStatusBgColor(element:any){
    if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
    {
      return '#F1FFF1';
    }
    else if(element.status.toUpperCase() == 'CANCELLED'){
      return '#FFF7F6'
    }
    else{
  return '#F6F6F6'
    }
     
    // console.log()
  }
  cancelStatusTextColor(element:any){
    if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
    {
      return '#006A00';
    }
    else if(element.status.toUpperCase() == 'CANCELLED'){
      return '#8B2A1D'
    }
    else{
  return '#454545'
    }
     
    // console.log()
  }
  cancelStatusBorderColor(element:any){
    if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
    {
      return '0.5px solid #009F3F';
    }
    else if(element.status.toUpperCase() == 'CANCELLED'){
      return '0.5px solid #8B2A1D'
    }
    else{
  return '0.5px solid #878787'
    }
     
    // console.log()
  }
}
